import moment, {now} from "moment";
import {Tag} from "antd";
import React from "react";
import {useDatetimeUtil} from "../../../../../core/util/datetime.util";

export function AttendanceStepDateAlertComponent(props: {
  endDate: string,
  showDate?: boolean,
}) {
  const { formDateInPtBr } = useDatetimeUtil()
  const dateTime = moment(props.endDate).set({ hours: 0, minute: 0, second: 0, millisecond: 0});
  const now = moment().set({ hours: 0, minute: 0, second: 0, millisecond: 0});
  const daysDiff = dateTime.diff(now, 'days');
  
  if (daysDiff < 0) {
    return <Tag color={'red'}>Atrasada {props.showDate ? `(${formDateInPtBr(props.endDate)})` : null }</Tag>
  }
  if (daysDiff === 0) {
    return  <Tag color={'warning'}> Vence Hoje {props.showDate ? `(${formDateInPtBr(props.endDate)})` : null } </Tag>
  }
  return  <Tag color={'processing'}> Vence em {daysDiff} dias {props.showDate ? `(${formDateInPtBr(props.endDate)})` : null } </Tag>
}